window.addEventListener("load", function () {
	const floatRight = document.getElementById("Float_right");
	if (!floatRight) return;

	const btnToggle = floatRight.querySelector(".btn-toggle");
	const btnTop = floatRight.querySelector(".btn-top");

	// Ẩn/hiện panel: trượt sang phải + đổi sprite mũi tên (hide → show)
	if (btnToggle) {
		btnToggle.addEventListener("click", function () {
			const hidden = floatRight.classList.toggle("is-hidden");
			btnToggle.classList.toggle("MS__sprite-right-btn-hide", !hidden);
			btnToggle.classList.toggle("MS__sprite-right-btn-show", hidden);
		});
	}

	// Cuộn mượt lên đầu trang
	if (btnTop) {
		btnTop.addEventListener("click", function () {
			window.scrollTo({ top: 0, behavior: "smooth" });
		});
	}
});
